import type { Thread } from "~/types";

export function initiativesForProjectAgent(input: {
  readonly threads: ReadonlyArray<Thread>;
  readonly projectId: string;
  readonly agentId: string;
}): ReadonlyArray<Thread> {
  return input.threads
    .filter(
      (thread) =>
        thread.projectId === input.projectId &&
        thread.kind === "initiative" &&
        thread.modelSelection.agentId === input.agentId &&
        thread.archivedAt === null,
    )
    .toSorted((a, b) => (b.updatedAt ?? b.createdAt).localeCompare(a.updatedAt ?? a.createdAt));
}
